export const isSitecore = typeof window.Sitecore !== typeof undefined

export const isXPE = typeof window.Sitecore !== typeof undefined && !!Sitecore.PageModes.PageEditor

export const rHostUrl = isSitecore ? process.env.HOST_URL : process.env.HOST

const getKey = (key, obj) => {
  if (typeof key === 'number') {
    return obj['number']
  } else {
    return obj[key]
  }
}
/**
 * Ensure's a string ends or starts, with or without, a character or substring.
 * If string already matches setted parameters, it will not be changed.
 * @param {string} text - Text to ensure
 * @param {'start'|'end'} pos - Ensure end or begining of text
 * @param {'with'|'without'} type - Ensure char is or not present in the string
 * @param {string} char - Character to unsure
 * @returns {string} - String with the passed parameters 
 */
export const ensure = (text, pos = 'start', type = 'with', char = '/') => {
  if (!text) {
    return text
  }
  if (!['start', 'end'].includes(pos) || !typeof pos === 'number') {
    throw new Error('unkown parameter: pos. allowed: "start", "end", Number')
  }
  if (!['with', 'without'].includes(type)) {
    throw new Error('unkown parameter: type. allowed: "with", "without"')
  }
  const indexes = {
    start: 0,
    end: text.length - 1,
    number: pos
  }
  let index = getKey(pos, indexes)
  if (text.charAt(index) === char && type === 'without') {
    const startPoints = {
      start: 1,
      end: 0,
      number: 0
    }
    const start = getKey(pos, startPoints)
    const endPoints = {
      start: undefined,
      end: index,
      number: index
    }
    const end = getKey(pos, endPoints)
    return text.slice(start, end) + (typeof pos === 'number' ? text.slice(pos + 1) : '')
  } else if (text.charAt(index) !== char && type === 'with') {
    if (pos === 'start') {
      return char + text
    } else if (pos === 'end') {
      return text + char
    } else {
      return text.slice(0, index) + char + text.slice(index)
    }
  } else {
    return text
  }
}

export const getApiUrl = (apiPath) => {
  const host = ensure(rHostUrl, 'end', 'without')
  const api = ensure(ensure(process.env.API_URL), 'end')
  const path = ensure(apiPath, 'start', 'without')
  return host + api + path
}
